export class NotificationDialogData {

    public header: string;

    public message?: string;

    public width? = '45rem';
}
